import * as S from './styles'

//images
import AntagonistaLogo from '../../assets/images/logo-antagonista-crusoe.svg'

//components

//hooks
import i18n from 'i18next'
import { useTranslation } from 'react-i18next'
import { IViewProps } from './types'
import PaymentContent from '../../shared/components/PaymentContent'

function HomeView(props: IViewProps) {

	const {
		onSubmit,
		errors,
		register,
		watch,
		checkCupom,
		cupomCheckResponse,
		submitOnBlur,
		userDetails,
		isDirty,
		isValid,
		creditCardInfos,
		resetCupom,
		resetVerifyCoupon,
		availableStates,
		availableCities,
		isLoading,
		setValue,
		resetField,
		setError,
		checkUser,
		subscriptionSelected,
		setSubscriptionSelected,
		clearErrors
	} = props

	const { t: translationHome } = useTranslation('home')
	const { t: translationRegister } = useTranslation('register')
	const { t: translationForm } = useTranslation('form')
    const { t: translationSummary } = useTranslation('summary')

	return (
		<>
			<S.Header>
				<S.ImagesContainer>
					<img src={AntagonistaLogo} alt='Logo o antagonista' />
				</S.ImagesContainer>
			</S.Header>

			<S.UserFormContainer>
				<S.ContentUserForm>
					<S.UserInput
						onSubmit={onSubmit}
						errors={errors}
						register={register}
						watch={watch}
						translation={translationRegister}
						cupomCheckResponse={cupomCheckResponse}
						submitOnBlur={submitOnBlur}
						userDetails={userDetails}
						isDirty={isDirty}
						isValid={isValid}
						creditCardInfos={creditCardInfos}
						resetCupom={resetCupom}
						resetVerifyCoupon={resetVerifyCoupon}
						availableStates={availableStates}
						availableCities={availableCities}
						isLoading={isLoading}
						setValue={setValue}
						resetField={resetField}
						setError={setError}
						checkUser={checkUser}
						translationHome={translationHome}
						translationRegister={translationRegister}
						translationForm={translationForm}
						clearErrors={clearErrors}
					/>
				</S.ContentUserForm>
			</S.UserFormContainer>

			<S.PaymentContainer>
				<S.ContentPayment>
					<PaymentContent
						onSubmit={onSubmit}
						errors={errors}
						register={register}
						watch={watch}
						translation={translationRegister}
						cupomCheckResponse={cupomCheckResponse}
						submitOnBlur={submitOnBlur}
						userDetails={userDetails}
						isDirty={isDirty}
						isValid={isValid}
						creditCardInfos={creditCardInfos}
						resetCupom={resetCupom}
						resetVerifyCoupon={resetVerifyCoupon}
						clearErrors={clearErrors}
						isLoading={isLoading}
						setValue={setValue}
						resetField={resetField}
						checkCupom={checkCupom}
						subscriptionSelected={subscriptionSelected}
						setSubscriptionSelected={setSubscriptionSelected}
						translationHome={translationHome}
						translationRegister={translationRegister}
						translationForm={translationForm}
						translationSummary={translationSummary}
					/>
				</S.ContentPayment>
			</S.PaymentContainer>
		</>
	)
}

export { HomeView }
